<template>
  <ModalSprinklers class="modal-sprinklers" v-if="getModalType === 'sprinklers' && getIsShowing" />
  <div class="modal-sprinklers-container" id="ms-selection" @click="this.handleSprinklerSelection()">
    <div class="modal-sprinklers-text-box">
      <div class="modal-display-group">
        <div class="modal-sprinklers-label">
          Model 
        </div>
        <div id="ms-model" class="modal-sprinklers-model">
          {{ model }}
        </div>
      </div>
      <div class="modal-display-group">
        <div class="modal-sprinklers-label">
          Plate 
        </div>
        <div id="ms-plate" class="modal-sprinklers-plate">
          {{ plate }}
        </div>
      </div>
      <div class="modal-display-group">
        <div class="modal-sprinklers-label">
          Nozzle 
        </div>
        <div id="ms-nozzle" class="modal-sprinklers-nozzle">
          {{ nozzle  }}
        </div>
      </div>
    </div>
    <div class="modal-sprinklers-divider"></div>
    <div>
      <p data-testid="modal-sprinklers-num" class="modal-sprinklers-num">
        {{ getSprinklerCount + 1 }}
      </p>
      <p data-testid="modal-sprinkler-in-use" class="modal-sprinklers-use">
        In Use
      </p>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { useSprinklerStore } from '@/store/SprinklerStore';
import ModalSprinklers from '@/modal/ModalSprinklers.vue';
import { useSegmentStore } from '@/store/SegmentStore';
import { useIdentityStore } from '@/store/IdentityStore';

export default {
  setup () {
    const sprinklerStore = useSprinklerStore();
    useIdentityStore().getUserProperties()
      .then(() => {
        sprinklerStore.fetchSprinklers();
        if (sprinklerStore.getSprinklerSelectedId != null) {
          sprinklerStore.fetchModels(sprinklerStore.getSprinklerSelectedId);
          sprinklerStore.fetchPlates(sprinklerStore.getModelSelectedId);
          sprinklerStore.fetchNozzles(sprinklerStore.getPlateSelectedId);
        }
      });
  },
  computed: {
    getModalType () {
      return useModalStore().getModalType;
    },
    getIsShowing () {
      return useModalStore().getIsShowing;
    },
    model () {
      const modelSelected = useSprinklerStore().getSelectedModel;
      return modelSelected === null ? 'Select' : modelSelected;
    },
    plate () {
      const plateSelected = useSprinklerStore().getSelectedPlate;
      return plateSelected === null ? 'Plate' : plateSelected.replace(/['"]+/g, '');
    },
    nozzle () {
      const nozzleSelected = useSprinklerStore().getSelectedNozzle;
      return nozzleSelected === null ? 'Sprinkler' : nozzleSelected.replace('NOZZLE','');
    },
    getSprinklerCount () {
      return useSegmentStore().getSprinklerCount;
    }
  },
  data () {
    return {
      sprinkler: {
        label: 'Sprinkler',
        icon: 'chart',
        value: 'sprinkler',
        orientation: 'top',
        marker: 'var(--nelson-gray)',
        func: this.handleSprinklerSelection,
      }
    };
  },
  methods: {
    handleSprinklerSelection () {
      useModalStore().showModal('sprinklers');
    }
  },
  components: { ModalSprinklers }
};
</script>

<style scoped>
.modal-sprinklers {
  top:  130px;
  z-index: 9999;
  position: fixed;
}
.sprinkler-selection-button {
  width: 100px;
  background-color: aqua;
  cursor: pointer;
}
.modal-sprinklers-container {
  background-color: #FFFFFF;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 5px solid var(--nelson-blue);
  cursor: pointer;
}
.modal-sprinklers-container:hover {
  background-color: #f2f2f2;
}
.modal-sprinklers-divider {
  height: 80%;
  width: 3px;
  background-color: #DDDDDD;
  margin: 1rem;
}
.modal-sprinklers-num {
  margin: 0;
  background-color: #FFFFFF;
  border-radius: 40%;
  padding: 1px 8px;
  font-weight: 800;
  font-size: 100%;
}
.modal-sprinklers-use {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 70%;
  margin: 4px 0 0;
}
@media (max-width: 1024px), (max-height: 1024px) {
  .modal-sprinklers-text-box {
    font-size: 70% !important;
  }
}
.modal-sprinklers-text-box {
  padding-left: 3px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 80%;
  gap: 0;
  margin-left:5px;
}
.modal-sprinkler-icon {
  width: 40px;
}
.modal-sprinklers-model {
  font-weight: 600;
}
.modal-sprinklers-label {
  font-weight: bold;
  width: 50px;
  text-align: right;
  padding-right: 10px;
}
.modal-display-group {
  display: flex;
}
</style>